import { PartnerMisconfigurationError } from '@/pages/external/ExternalPremiumLogin/ErrorComponents'
import { useSearchParams } from 'react-router-dom'

import { useTrackPaymentFlow } from '../trackingPaymentFlow'
import { TRACKING_TYPES } from '@/constants/TrackingConstants'
import { useErrorBoundary } from 'react-error-boundary'
import { ExternalRevenueCatProvider } from './RevenueCatProvider'
import { User } from '@/types/User'

function isBase64(str: string | null): boolean {
  if (str === null) return false
  try {
    return btoa(atob(str)) === str
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (_) {
    return false
  }
}

export function PremiumPaymentSession({
  children,
  token,
  base64ClientKey,
  user,
}: {
  children: React.ReactNode
  token: string
  base64ClientKey: string | null
  user: User
}) {
  const [searchParams] = useSearchParams()
  const clientKey = base64ClientKey || searchParams.get('clientKey')

  const track = useTrackPaymentFlow()
  const { showBoundary } = useErrorBoundary()

  if (clientKey === null) {
    track(TRACKING_TYPES.PAYMENT_FAILED)
    showBoundary(new PartnerMisconfigurationError('Client key is required'))
    return <></>
  } else if (!isBase64(clientKey)) {
    track(TRACKING_TYPES.PAYMENT_FAILED)
    showBoundary(new PartnerMisconfigurationError('Invalid client key format; expected base64'))
    return <></>
  } else {
    return (
      <ExternalRevenueCatProvider token={token} user={user}>
        {children}
      </ExternalRevenueCatProvider>
    )
  }
}
